

<mat-sidenav-container style="height:100%;">
  <mat-sidenav class="custom-sidebar-menu" #sidenav mode="over" style="background-color: #153A57; cursor: pointer; overflow: hidden; margin-top: 14px !important"
             [ngStyle]="{'width': sidenavWidth + 'em','transition': 'width 0.3s ease-in-out', 'maxWidth': '100vw'}"
             (mouseenter)="increase()"
             (mouseleave)="decrease()"
             [disableClose]="true"
             opened="true">
    <mat-nav-list style="padding-top: 57px;" (mouseenter)="interact()" (mouseleave)="leave($event)">
      <div *ngIf="showProjectsContainer"
          class="project-container"
         [ngClass]="{'open': showProjectsContainer, 'closed': !showProjectsContainer}"
         (scroll)="onScroll($event)">
        <mat-form-field>
          <input matInput [(ngModel)]="searchProjectName" placeholder="{{'search' | localize}}" />
        </mat-form-field>
        <div class="project-item"
             (click)="onSelectedProject(item.id)"
             *ngFor="let item of filterProject()"
             [ngClass]="{'highlighted-project': item.id === selectedProjectId}">
          {{ item.projectName }}
        </div>
        <!--<button *ngIf="authControl('AddProject')" [ngClass]="_appsService.classes" class="add-project-button">
      <mat-icon style="color:white; font-size:x-large">add</mat-icon>
      {{'newProject' | localize}}
    </button>-->
      </div>
      <mat-list-item [ngClass]="{'center-content': sidenavWidth <= 6, 'expanded-sidenav': sidenavWidth > 6}"
                     [ngStyle]="{'background-color': sidenavWidth > 6 ? '#153A57' : '#204D71', 'border-bottom':'1px solid #497DA6'}"
                     routerLinkActive="active"
                     [disableRipple]="true"
                     (click)="displayProjects()">

        <!-- 🔹 Collapsed mode: only image -->
        <ng-container *ngIf="sidenavWidth <= 6">
          <img [src]="'assets/icons/sidemenu/basarsoft-vector.png'" style="width:24px;" />
        </ng-container>

        <!-- 🔹 Expanded mode: image + text + dropdown -->
        <ng-container *ngIf="sidenavWidth > 6">
          <div style="display: flex; justify-content:space-between; background-color: #204D71 !important; border-radius: 20px; padding: 6px 14px; border: 1px solid #497DA6; align-items: center; width:290px;">
            <div style="display:flex;">
              <img [src]="'assets/icons/sidemenu/basarsoft-vector.png'" style="width:24px;" />

              <div class="sidenav-item">
                <p [matTooltip]="selectedProjectName"
                   style="margin-bottom:0; color:white; margin-left:10px; font-size:13px;"
                   [ngClass]="this._appsService.classes">
                  {{ selectedProjectName | truncate:truncateLimit }}
                </p>
              </div>
            </div>
            <mat-icon style="margin-left:30px;" [ngClass]="{'rotate-down': showProjectsContainer, 'rotate-right': !showProjectsContainer}">
              expand_more
            </mat-icon>
          </div>
        </ng-container>

      </mat-list-item>



      <ng-container *ngFor="let sideMenuItem of sideMenuList; let i = index">
        <mat-list-item [attr.id]="sideMenuItem.tutorialId || ('tutorial-sidemenu-' + sideMenuItem.menuName)"
                       [ngClass]="{'center-content': sidenavWidth <= 6, 'expanded-sidenav': sidenavWidth > 6}"
                       routerLinkActive="active"
                       [disableRipple]="true"
                       (click)="onSideMenuItemClick(i)" [routerLink]="[sideMenuItem.path]">

          <img [src]="'assets/icons/sidemenu/' + sideMenuItem.icon + '.png'" style="width:24px;" />
          <div *ngIf="sidenavWidth > 6" class="sidenav-item">
            <p style="margin-bottom:0; color:white; margin-left:10px;" [ngClass]="this._appsService.classes">
              {{ sideMenuItem.menuName | localize }}
            </p>
            <!--<div *ngIf="sideMenuItem.order == 0 && showProjectsContainer" class="project-container">
          <div class="project-item"
               (click)="onSelectedProject(item.id)"
               *ngFor="let item of _appsService.projects"
               [ngClass]="{'highlighted-project': item.id === selectedProjectId}">
            {{ item.projectName }}
          </div>
          <button class="add-project-button">+ Yeni Proje</button>
        </div>-->
          </div>
          <button mat-icon-button *ngIf="sideMenuItem.hasDrop && sidenavWidth > 6" style="position: absolute; right: 0;">
            <mat-icon [ngClass]="{'rotate-icon': true, 'rotate-icon-open': sideMenuItem.dropState,'rotate-icon-close': !sideMenuItem.dropState}">
              {{'expand_less'}}
            </mat-icon>

            <!--<mat-icon>{{ sideMenuItem.dropState ? 'expand_less' : 'expand_more' }}</mat-icon>-->
          </button>
        </mat-list-item>

        <ng-container>
          <div [ngClass]="{'submenu-container': true, 'open': sideMenuItem.dropState}">
            <ng-container *ngFor="let subMenuItem of sideMenuItem.subMenuItems">
              <mat-list-item [attr.id]="subMenuItem.tutorialId" *ngIf="subMenuItem.operation == 0 && subMenuItem.type != formType.PoiCategory" style="width:100%; display:flex; justify-content:flex-start;" (click)="onSubMenuItemClick(subMenuItem)">
                <div style="display: flex; justify-content: center; position: absolute; top: 0; left: 15%; height: 100%; align-items: center;">
                  <mat-icon style="margin-right:6px;" *ngIf="subMenuItem.icon.length > 0" mat-list-icon>
                    {{subMenuItem.icon}}
                  </mat-icon>
                  <span style="color:white;" [ngClass]="this._appsService.classes">{{subMenuItem?.menuName | localize}}</span>
                </div>
              </mat-list-item>
              <mat-list-item [attr.id]="subMenuItem.tutorialId" *ngIf="subMenuItem.operation == 0 && subMenuItem.type == formType.PoiCategory && _appsService.staticPoiExsit" style="width:100%; display:flex; justify-content:flex-start;" (click)="onSubMenuItemClick(subMenuItem)">
                <div style="display: flex; justify-content: center; position: absolute; top: 0; left: 15%; height: 100%; align-items: center;">
                  <mat-icon style="margin-right:6px;" *ngIf="subMenuItem.icon.length > 0" mat-list-icon>
                    {{subMenuItem.icon}}
                  </mat-icon>
                  <span style="color:white;" [ngClass]="this._appsService.classes">{{subMenuItem?.menuName | localize}}</span>
                </div>
              </mat-list-item>
              <mat-list-item id="tutorial-workforce-form-select" *ngIf="subMenuItem.operation == 1 && subMenuItem.type == 0" style="width:100%; display:flex; justify-content:flex-start;">
                <div style="display: flex; justify-content: center; position: absolute; top: 0; left: 12%; height: 100%; width: 70%; align-items: center; background-color: #153A57">
                  <mat-form-field style="width:100%;" appearance="fill" class="team-select custom-class">
                    <mat-select style="color:white" placeholder="İş Formu" [(value)]="selectedWorkForm" (selectionChange)="onItemSelected(subMenuItem.type,$event)" [ngClass]="this._appsService.classes">
                      <mat-option *ngFor="let item of _appsService.workForms" [value]="item" [ngClass]="this._appsService.classes">{{item.templateName}}</mat-option>
                    </mat-select>
                    <mat-icon style="color: white">
                      {{'expand_more'}}
                    </mat-icon>
                  </mat-form-field>
                </div>
              </mat-list-item>
              <mat-list-item *ngIf="subMenuItem.operation == 1 && subMenuItem.type == 12" style="width:100%; display:flex; justify-content:flex-start;">
                <div style="display: flex; justify-content: center; position: absolute; top: 0; left: 12%; height: 100%; width: 70%; align-items: center; background-color: #153A57">
                  <mat-form-field style="width:100%;" appearance="fill" class="team-select custom-class">
                    <mat-select style="color: white; font-size: 13px;" placeholder="Anket Formu" [(value)]="selectedDefaultForm" (selectionChange)="onItemSelected(subMenuItem.type,$event)" [ngClass]="this._appsService.classes">
                      <mat-option *ngFor="let item of _appsService.defaultForms" [value]="item">{{item.templateName}}</mat-option>
                    </mat-select>
                    <mat-icon style="color: white">
                      {{'expand_more'}}
                    </mat-icon>
                  </mat-form-field>
                </div>
              </mat-list-item>
              <mat-list-item class="custom-mdc-list" *ngIf="subMenuItem.operation == 2 && subMenuItem.type == formType.Poi && dynamicCheckAuth(formActionType.Add, formType.Poi)" style="width:100%; display:flex; justify-content:flex-start;">
                <div style="width:100%;">
                  <button style="width: 100%; color:white; border-radius: 5px;" (click)="onSubMenuMapOperationClick(subMenuItem)" mat-stroked-button color="primary" class="add-team-btn" [ngClass]="this._appsService.classes">
                    {{subMenuItem.menuName | localize}} <mat-icon class="add-team-icon">add</mat-icon>
                  </button>
                </div>
              </mat-list-item>
              <mat-list-item *ngIf="subMenuItem.operation == 1 && subMenuItem.type == 9" style="width:100%; display:flex; justify-content:flex-start;">
                <div style="display: flex; justify-content: center; position: absolute; top: 0; left: 15%; height: 100%; width: 70%; align-items: center;background-color: #153A57">
                  <mat-form-field style="width:100%;" appearance="fill" class="team-select custom-class">
                    <mat-select style="color: white; font-size: 13px;" placeholder="Bölge Formu" [(ngModel)]="selectedRegionForm" (selectionChange)="onItemSelected(subMenuItem.type,$event)">
                      <mat-option *ngFor="let item of _appsService.regionForms" [value]="item">{{item.templateName}}</mat-option>
                    </mat-select>
                    <mat-icon style="color: white">
                      {{'expand_more'}}
                    </mat-icon>
                  </mat-form-field>
                </div>
              </mat-list-item>
              <mat-list-item class="custom-mdc-list" *ngIf="subMenuItem.operation == 2 && subMenuItem.type == formType.Region && dynamicCheckAuth(formActionType.Add, formType.Region)" style="width:100%; display:flex; justify-content:flex-start;">
                <div style="width:100%;">
                  <button style="width: 100%; color:white; font-size:12.5px; border-radius: 5px" (click)="onSubMenuMapOperationClick(subMenuItem)" mat-stroked-button color="primary" class="add-team-btn" [ngClass]="this._appsService.classes">
                    {{subMenuItem.menuName | localize}} <mat-icon class="add-team-icon">add</mat-icon>
                  </button>
                </div>
              </mat-list-item>
            </ng-container>
          </div>
        </ng-container>


        <hr *ngIf="[0, 3].includes(sideMenuItem.order)" style="margin-left: 14px; margin-right: 18px; border-color: #23547A;" />
      </ng-container>
    </mat-nav-list>
  </mat-sidenav>

  <!--<div class="example-sidenav-content">-->
  <!-- <router-outlet></router-outlet> -->
  <!--<mat-icon (click)="sidenav.toggle()" class="sidenav-menu">menu</mat-icon>
  </div>-->


</mat-sidenav-container>



